import { CommentsService } from '@/service/CommentsService'
import Model from './Model'
import { IUserSocials } from './Users'

export interface IComments {
  _id?: string
  locationId: string
  groupId: string
  postId: string
  parentId?: string
  content: string
  attachments?: Array<any>
  mentions: Array<{ contactId: string }>
  channelMentions: Array<{ channelId: string }>
  eventMentions: Array<{ eventId: string }>
  courseMentions: Array<{ courseId: string }>
  createdBy?: string
  reactions?: Map<string, number>
  repliesCount: number
  replies?: IComments[]
  createdAt?: string
  current_user_reactions?: any
  lastEditedAt?: string
  user?: {
    fullName: string
    avatar: string
    slug: string
    contactId: string
    gamificationMeta?: {
      points: number
      level: number
    }
    socials?: IUserSocials
  }
  isHighlighted?: boolean
  expandReplies?: boolean
  notifyAllGroupMembers?: boolean
}

export default class Comments extends Model {
  constructor(payload: IComments) {
    super(payload, CommentsService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get reactions(): object {
    return this._data.reactions
  }

  set reactions(reactions: object) {
    this._data.reactions = reactions
  }

  get current_user_reactions(): object {
    return this._data.current_user_reactions
  }

  set current_user_reactions(current_user_reactions: object) {
    this._data.current_user_reactions = current_user_reactions
  }

  get postId(): string {
    return this._data.postId
  }

  set postId(postId: string) {
    this._data.postId = postId
  }

  get title(): string {
    return this._data.title
  }

  get parentId(): string {
    return this._data.parentId
  }
  set parentId(parentId: string) {
    this._data.parentId = parentId
  }

  get content(): string {
    return this._data.content
  }

  set content(content: string) {
    this._data.content = content
  }

  get attachments(): [] | undefined {
    return this._data.attachments
  }

  set attachments(attachments: [] | undefined) {
    this._data.attachments = attachments
  }

  get mentions(): [] {
    return this._data.mentions
  }

  set mentions(mentions: []) {
    this._data.mentions = mentions
  }

  get thumbnailUrl(): string | undefined {
    return this._data.thumbnailUrl
  }

  set thumbnailUrl(thumbnailUrl: string | undefined) {
    this._data.thumbnailUrl = thumbnailUrl
  }

  get createdBy(): string {
    return this._data.createdBy
  }

  set createdBy(createdBy: string) {
    this._data.createdBy = createdBy
  }

  get createdAt(): string {
    return this._data.createdAt
  }

  set createdAt(createdAt: string) {
    this._data.createdAt = createdAt
  }

  get reactionType(): Map<string, number> | undefined {
    return this._data.reactionType
  }

  set reactionType(reactionType: Map<string, number> | undefined) {
    this._data.reactionType = reactionType
  }

  get repliesCount(): number {
    return this._data.repliesCount
  }

  set repliesCount(repliesCount: number) {
    this._data.repliesCount = repliesCount
  }

  get user(): {
    name: string
    avatar: string
    slug: string
    contactId: string
  } {
    return this._data.user
  }

  set user(user: {
    name: string
    avatar: string
    slug: string
    contactId: string
  }) {
    this._data.user = user
  }
}
